import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import RegionForm from './RegionForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Region'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Region' : 'Edit Region'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Region', href: '/region' },
          ]}
        />
        <RegionForm />
      </Container>
    </Page>
  );
};

export default index;
